// src/app/app.component.ts este ts sirve para app.html para los enrrutamientos y el diseño de la pagina
import { Component, ViewChild } from '@angular/core';
import { SharedMaterialModule } from './shared/shared-material.module';
import { RouterModule } from '@angular/router';


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
     SharedMaterialModule,  RouterModule 
],
  templateUrl: './app.html',
  styleUrls: ['./app.css']
})
export class App {
 onMenuClick() {
    console.log('Menú clickeado');
  }
  title = 'HyLpage';
}
